import { ReactNode } from "react";
import { Col, Span } from "@ir/ui";

interface EditDeductionDetailsProps {
  label?: string;
  children?: ReactNode;
  span?: number;
  md?: number;
  className?: string;
}

const EditDeductionDetailsCol = ({ label, children, span = 6, md = 3, className }: EditDeductionDetailsProps) => {
  return (
    <Col span={span} md={md} className={className}>
      {label && <Span className="text-grey-600 font-regular text-xs mb-0">{label}</Span>}
      {children}
    </Col>
  );
};

export default EditDeductionDetailsCol;
